import styled from "styled-components";

export const img = styled("div")<any>`
  width=155px,
  height=70px;
`;